// extracted by mini-css-extract-plugin
module.exports = {"root":"Share-module--root--3p1Va","popup":"Share-module--popup--2R3DI","btn":"Share-module--btn--8wPvf"};